import { Serializer } from '@/services/serializer';

export default {

    namespaced: true,

    state: {     
        customerID: null,
        aud: null,
        email: null,  
        exp: null,
        iss: null,   
        jti: null,
        nameID:null,
        uniqueName:null,
        token:null,
        permissions:null,
        customerName:null
    },

    getters: { 

        loggedIn (state) {
            return state.token !== null && state.token !== undefined && state.token !== 'null';
        },     

        isAdmin (state) {            
            if (!state.permissions || !Array.isArray(state.permissions) ) return false;
            return state.permissions.some(p => p === 'Admin');
        },

        get (state) {
            return {
                customerID: state.customerID,
                customerName: state.customerName,
                aud: state.aud,
                email: state.email,  
                exp: state.exp,
                iss: state.iss,   
                jti: state.jti,
                nameID:state.nameID,
                uniqueName:state.uniqueName,
                token:state.token,
                permissions:state.permissions
            };
        }
    },

    mutations: { 

        INIT (state, session) {
            state.customerID = session.customerID;
            state.customerName = session.customerName;
            state.aud = session.aud;
            state.email = session.email;
            state.exp = session.exp;
            state.iss = session.iss;
            state.jti = session.jti;
            state.nameID = session.nameID;
            state.uniqueName = session.uniqueName;
            state.token = session.token;
            state.permissions = session.permissions;
        },

        RESET (state) {
            state.customerID = null;
            state.customerName = null;
            state.aud = null;
            state.email = null;
            state.exp = null;
            state.iss = null;
            state.jti = null;
            state.nameID = null;
            state.uniqueName = null;
            state.token = null;
            state.permissions = null;
        }
    },

    actions: { 

        init ({ commit, dispatch }, session) {
            commit('INIT', session);
            dispatch('saveStore');
        },

        reset ({ commit, dispatch }) {
            commit('RESET');
            dispatch('resetStore');
        },

        loadStore ({ commit }) {  
            commit('INIT', {
                customerID: sessionStorage.customerID,
                customerName: sessionStorage.customerName,
                aud: sessionStorage.aud,
                email: sessionStorage.email,  
                exp: sessionStorage.exp,
                iss: sessionStorage.iss,   
                jti: sessionStorage.jti,
                nameID:sessionStorage.nameID,
                uniqueName:sessionStorage.uniqueName,
                token:sessionStorage.token,
                permissions: new Serializer().deserialize(sessionStorage.permissions) || []
            });
        },

        saveStore ({ state }) {
            sessionStorage.customerID = state.customerID;
            sessionStorage.customerName = state.customerName;
            sessionStorage.aud = state.aud;
            sessionStorage.email = state.email;  
            sessionStorage.exp = state.exp;
            sessionStorage.iss = state.iss;   
            sessionStorage.jti = state.jti;
            sessionStorage.nameID = state.nameID;
            sessionStorage.uniqueName = state.uniqueName;
            sessionStorage.token = state.token;

            sessionStorage.permissions = new Serializer().serialize(state.permissions);
        },

        resetStore() {
           sessionStorage.removeItem('customerID');
           sessionStorage.removeItem('customerName');
           sessionStorage.removeItem('aud');
           sessionStorage.removeItem('email');
           sessionStorage.removeItem('exp');
           sessionStorage.removeItem('iss');
           sessionStorage.removeItem('jti');
           sessionStorage.removeItem('nameID');
           sessionStorage.removeItem('uniqueName');
           sessionStorage.removeItem('token');
           sessionStorage.removeItem('permissions');
        },

        hasPermission({ state }, permission) {
            if (!state.permissions || !Array.isArray(state.permissions) ) return false;

            return state.permission.some(p => p === permission);
        }

    }   

};